module.exports = __webpack_public_path__ + "static/media/audio@3x.55a7920e.png";